import html2canvas from "html2canvas";
import JsPDF from "jspdf";

/**
 * @param  ele          要生成 pdf 的DOM元素（容器）
 * @param  padfName     PDF文件生成后的文件名字
 * @param PDFpages   是否分页
 * @param linkConfigList  pdf超链接配置  ：{link:'',x:0,y:0,width:0,height:0}
 * @param autoDownload  是否自动下载
 * */

function downloadPDF(
  ele,
  pdfName,
  PDFpages = true,
  linkConfigList = [],
  autoDownload = false
) {
  const eleW = ele.offsetWidth; // 获得该容器的宽
  const eleH = ele.offsetHeight; // 获得该容器的高

  const eleOffsetTop = ele.offsetTop; // 获得该容器到文档顶部的距离
  const eleOffsetLeft = ele.offsetLeft; // 获得该容器到文档最左的距离

  // const canvas = document.createElement("canvas");
  const canvas = document.createElement("canvas");
  let abs = 0;

  const win_in =
    document.documentElement.clientWidth || document.body.clientWidth; // 获得当前可视窗口的宽度（不包含滚动条）
  const win_out = window.innerWidth; // 获得当前窗口的宽度（包含滚动条）

  if (win_out > win_in) {
    // abs = (win_o - win_i)/2;    // 获得滚动条长度的一半
    abs = (win_out - win_in) / 2; // 获得滚动条宽度的一半
    // console.log(a, '新abs');
  }

  canvas.width = eleW * 2; // 将画布宽&&高放大两倍
  canvas.height = eleH * 2;

  const context = canvas.getContext("2d");

  context.scale(2, 2);

  context.translate(-eleOffsetLeft - abs, -eleOffsetTop);
  // 这里默认横向没有滚动条的情况，因为offset.left(),有无滚动条的时候存在差值，因此
  // translate的时候，要把这个差值去掉

  // setTimeout(() => {
  //页面转canvas
  html2canvas(ele, {
    dpi: 300, //清晰度
    scale: 3, // 提升画面质量，但是会增加文件大小
    useCORS: true, //允许canvas画布内 可以跨域请求外部链接图片, 允许跨域请求。
    onclone: function(documentClone) {
      //safari 可能有细微不同 权衡之计
      documentClone
        .querySelectorAll(".new-q-block .tag,.green-tag")
        .forEach(item => {
          item.style.display = "inline-block";
          const height = item.offsetHeight;
          item.style.lineHeight = height + "px";
        });
      documentClone.querySelectorAll(".mainBox .headImg").forEach(item => {
        item.style.height = "unset";
      });
      documentClone.querySelectorAll(".pdf-pic-fix").forEach(item => {
        item.style.maxWidth = "100%";
        item.style.minHeight = "100%";
        item.style.height = "unset";
        item.style.width = "unset";
      });
    }
  })
    .then(canvas => {
      if (PDFpages) {
        //第一种 分页pdf
        const contentWidth = canvas.width;
        const contentHeight = canvas.height;
        //一页pdf显示html页面生成的canvas高度;
        const pageHeight = (contentWidth / 592.28) * 841.89;
        //未生成pdf的html页面高度
        let leftHeight = contentHeight;
        //页面偏移
        let position = 0;
        //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
        const imgWidth = 595.28;
        const imgHeight = (595.28 / contentWidth) * contentHeight;

        const pageData = canvas.toDataURL("image/jpeg", 1.0);

        const pdf = new JsPDF("", "pt", "a4");

        //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
        //当内容未超过pdf一页显示的范围，无需分页
        if (leftHeight < pageHeight) {
          //在pdf.addImage(pageData, 'JPEG', 左，上，宽度，高度)设置在pdf中显示；
          pdf.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
          // pdf.addImage(pageData, 'JPEG', 20, 40, imgWidth, imgHeight);
        } else {
          // 分页
          while (leftHeight > 0) {
            pdf.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
            leftHeight -= pageHeight;
            position -= 841.89;
            //避免添加空白页
            if (leftHeight > 0) {
              pdf.addPage();
            }
          }
        }

        //可动态生成
        pdf.save(pdfName);
      } else {
        //第二种方式
        /**jspdf将html转为pdf一页显示不截断，整体思路：
         * 1. 获取DOM
         * 2. 将DOM转换为canvas
         * 3. 获取canvas的宽度、高度（稍微大一点）
         * 4. 将pdf的宽高设置为canvas的宽高
         * 5. 将canvas转为图片
         * 6. 实例化jspdf，将内容图片放在pdf中（因为内容宽高和pdf宽高一样，就只需要一页，也防止内容截断问题）
         */

        // 得到canvas画布的单位是px 像素单位
        const contentWidth = canvas.width;
        const contentHeight = canvas.height;
        // 将canvas转为base64图片
        const pageData = canvas.toDataURL("image/jpeg", 1.0);

        // 设置pdf的尺寸，pdf要使用pt单位 已知 1pt/1px = 0.75   pt = (px/scale)* 0.75
        // 2为上面的scale 缩放了2倍
        // const pdfX = ((contentWidth + 10) / 3) * 0.75;
        const pdfX = ((contentWidth + 0) / 3) * 0.75;
        const pdfY = ((contentHeight + 0) / 3) * 0.75; // + number 为底部留白

        // 设置内容图片的尺寸，img是pt单位
        const imgX = pdfX;
        const imgY = (contentHeight / 3) * 0.75; //内容图片这里不需要留白的距离

        // 初始化jspdf 第一个参数方向：默认''时为纵向，第二个参数设置pdf内容图片使用的长度单位为pt，第三个参数为PDF的大小，单位是pt
        const PDF = new JsPDF("", "pt", [pdfX, pdfY]);

        // 将内容图片添加到pdf中，因为内容宽高和pdf宽高一样，就只需要一页，位置就是 0,0
        PDF.addImage(pageData, "jpeg", 0, 0, imgX, imgY);

        if (linkConfigList.length) {
          linkConfigList.forEach(item => {
            // PDF.setDrawColor(255, 0, 0);
            // PDF.rect(
            //   item.x * 0.75,
            //   item.y * 0.75,
            //   item.width * 0.75,
            //   item.height * 0.75
            // );
            PDF.link(
              item.x * 0.75,
              item.y * 0.75,
              item.width * 0.75,
              item.height * 0.75,
              { url: item.link }
            );
          });
        }
        PDF.save(pdfName); //文件名
      }
    })
    .then(() => {
      if (autoDownload) {
        setTimeout(() => {
          window.close();
        }, 2000);
      }
    });
  // }, 1000);
}

export default {
  downloadPDF
};
